import RevisableLanguagePack from "../../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import HubEvent from "../../../../../app/hub/event/HubEvent";
import MediatorManager from "../../../../../core/application/MediatorManager";
import ClickEaterFactory from "../../../../../core/ui/ClickEaterFactory";
import FileExplorerModel from "../../../../files/model/FileExplorerModel";
import FileInteractionEvent from "../../../../files/model/FileInteractionEvent";
import FileModel from "../../../../files/model/FileModel";
import LaptopNavigateEvent from "../../../model/LaptopNavigateEvent";
import LaptopSkinKeyRegistry from "../../../model/LaptopSkinKeyRegistry";
import AbstractLaptopMediator from "../../AbstractLaptopMediator";

export default class LaptopFileViewerScreenMediator extends AbstractLaptopMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {FileModel} fileModel 
     * @param {FileExplorerModel} fileExplorerModel 
     * @param {RevisableLanguagePack} languagePack 
     * @param {MediatorManager} mediatorManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, fileModel, fileExplorerModel, languagePack, mediatorManager, keyDecisionsConfig) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._fileModel = fileModel;
        this._fileExplorerModel = fileExplorerModel;
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
        this._keyDecisionsConfig = keyDecisionsConfig;

        this._file = this.getCustomData().file;
    }

    initialize() {
        super.initialize();
        this._hideKeyDecisionLogo();

        this._target.fileViewer.customData = {
            file: this._file
        };
        if (this._file.fileIsNew && this._keyDecisionsConfig.contentUnlocksKeyDecision(this._file)) {
            this._showKeyDecisionLogo();
        }
        this._fileViewerMediator = this._mediatorManager.createMediator(this._target.fileViewer, LaptopSkinKeyRegistry.FILE_VIEWER_SKIN);

        this._backButton = this.createButton(this._target.backButton, this._handleBackButton.bind(this));
        this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButton.bind(this));
    }

    destroy() {
        super.destroy();

        this._fileViewerMediator.destroy();

        // Reset to root directory
        this._fileExplorerModel.currentFileTreeNode = this._fileModel.fileTree.root;
    }

    _hideKeyDecisionLogo() {
        this._target.NewKeyDecisionFound.alpha = 0;
    }

    _showKeyDecisionLogo() {
        this.dispatch(LaptopNavigateEvent.HIDE_OVERLAY);
        this._target.NewKeyDecisionFound.alpha = 1;
        this._target.NewKeyDecisionFound.timeline.loop = 0;
        this._target.NewKeyDecisionFound.timeline.gotoAndPlay(0);
        this._target.NewKeyDecisionFound.timeline.on('change', (evt) => {
            if (this._target.NewKeyDecisionFound.timeline.paused) {
                evt.remove();
                this.dispatch(HubEvent.REFRESH_KEY_DECISIONS_LIST);
            }
        });
    }

    _handleBackButton() {
        this._hideKeyDecisionLogo();
        this._close();
    }

    _handleCloseButton() {
        this._hideKeyDecisionLogo();
        this._close();
    }

    _close() {
        const evt = new FileInteractionEvent(FileInteractionEvent.CLOSE_FILE, this._file);
        this.dispatch(evt.type, { data: evt });
    }
}